(function () {
  'use strict';

  const QTY_MIN = 1;
  const QTY_MAX = 10;

  async function applyDiscountCodes(newCodes) {
    try {
      await window.ShopifyConstant.applyCartDiscountCodes(newCodes);
    } catch (error) {
      window.ShopifyConstant.reportCartDiscountError(error);
    }
  }

  function initBundle(container) {
    const sectionId = container.dataset.sectionId;
    const config = (window.__LEPRO_BUNDLE__ || {})[sectionId];
    if (!config) return;

    const addBtn = container.querySelector('.lepro-bundle__add-btn');
    const subtotalEl = container.querySelector('.lepro-bundle__subtotal-value');
    const originalEl = container.querySelector('.lepro-bundle__original-value');
    const saveEl = container.querySelector('.lepro-bundle__save');
    const originalRow = container.querySelector('.lepro-bundle__original-row');

    // ── Quantity controls ──────────────────────────────────────────────
    const clamp = (v) => Math.max(QTY_MIN, Math.min(QTY_MAX, v));

    function bindQtyControls(item) {
      const minusBtn = item.querySelector('.lepro-bundle__qty-btn--minus');
      const plusBtn = item.querySelector('.lepro-bundle__qty-btn--plus');
      const input = item.querySelector('.lepro-bundle__qty-input');
      if (!minusBtn || !plusBtn || !input) return;

      const updateQtyButtons = () => {
        const v = parseInt(input.value, 10);
        minusBtn.disabled = v <= QTY_MIN;
        plusBtn.disabled = v >= QTY_MAX;
      };

      minusBtn.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) - 1);
        updateQtyButtons();
        recalculate();
      });

      plusBtn.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) + 1);
        updateQtyButtons();
        recalculate();
      });

      input.addEventListener('change', () => {
        const v = parseInt(input.value, 10) || QTY_MIN;
        input.value = clamp(v);
        updateQtyButtons();
        recalculate();
      });

      updateQtyButtons();
    }

    // Main product qty
    const mainItem = container.querySelector('.lepro-bundle__item--main');
    if (mainItem) bindQtyControls(mainItem);

    // Addon products qty + checkbox
    container.querySelectorAll('.lepro-bundle__item--addon').forEach((item) => {
      bindQtyControls(item);

      const checkbox = item.querySelector('.lepro-bundle__checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          item.classList.toggle('is-unchecked', !checkbox.checked);
          recalculate();
        });
      }
    });

    // ── Price calculation ──────────────────────────────────────────────
    function recalculate() {
      const mainQty = mainItem
        ? parseInt(mainItem.querySelector('.lepro-bundle__qty-input')?.value, 10) || 1
        : 1;
      let subtotal = config.mainPrice * mainQty;
      let original = (config.mainComparePrice > config.mainPrice
        ? config.mainComparePrice
        : config.mainPrice) * mainQty;
      container.querySelectorAll('.lepro-bundle__item--addon').forEach((item) => {
        const checkbox = item.querySelector('.lepro-bundle__checkbox');
        if (!checkbox.checked) return;

        const qty = parseInt(item.querySelector('.lepro-bundle__qty-input').value, 10) || 1;
        const price = parseInt(item.dataset.price, 10) || 0;
        const comparePrice = parseInt(item.dataset.comparePrice, 10) || 0;

        subtotal += price * qty;
        original += (comparePrice > price ? comparePrice : price) * qty;
      });

      const finalSubtotal = subtotal;

      const save = original - finalSubtotal;

      // Format as money (cents → dollars)
      const fmt = (cents) => {
        const dollars = (cents / 100).toFixed(2);
        return config.moneyFormat
          ? config.moneyFormat
              .replace(/\{\{\s*amount\s*\}\}/g, dollars)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
          : `$${dollars}`;
      };

      if (subtotalEl) subtotalEl.textContent = fmt(finalSubtotal);

      if (save > 0) {
        if (originalEl) originalEl.textContent = fmt(original);
        if (saveEl) saveEl.textContent = `Save: ${fmt(save)}`;
        if (originalRow) originalRow.style.display = '';
        if (saveEl) saveEl.style.display = '';
      } else {
        if (originalRow) originalRow.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    recalculate();

    // ── Add to Cart ────────────────────────────────────────────────────
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [];

        // Main product
        const mainQty = mainItem
          ? parseInt(mainItem.querySelector('.lepro-bundle__qty-input')?.value, 10) || 1
          : 1;
        items.push({
          id: config.mainVariantId,
          quantity: mainQty
        });

        // Checked bundle products
        container.querySelectorAll('.lepro-bundle__item--addon').forEach((item) => {
          const checkbox = item.querySelector('.lepro-bundle__checkbox');
          if (!checkbox.checked) return;
          const qty = parseInt(item.querySelector('.lepro-bundle__qty-input').value, 10) || 1;
          const variantId = parseInt(item.dataset.variantId, 10);
          if (variantId) {
            items.push({ id: variantId, quantity: qty });
          }
        });

        const originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        try {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = cart && typeof cart.getSectionsToRender === 'function'
            ? cart.getSectionsToRender().map((s) => s.id)
            : [];

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
          });

          if (!res.ok) throw new Error('Cart error');

          const data = await res.json();

          // 收集主商品 + 各 addon 自己的折扣码
          const discountCodes = [];
          const offCodeEl = document.querySelector('lepro-off-code');
          if (offCodeEl && offCodeEl.code) discountCodes.push(offCodeEl.code);
          container.querySelectorAll('.lepro-bundle__item--addon').forEach((item) => {
            const cb = item.querySelector('.lepro-bundle__checkbox');
            if (!cb || !cb.checked) return;
            if (item.dataset.discountCode) discountCodes.push(item.dataset.discountCode);
          });
          await applyDiscountCodes(discountCodes);

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          }
        } catch (err) {
          console.error('Bundle add to cart failed:', err);
        } finally {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }
      });
    }
  }

  // ── 初始化 & 生命周期 ──────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.lepro-bundle:not([data-bundle-init])').forEach((container) => {
      container.dataset.bundleInit = '1';
      initBundle(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('.lepro-bundle');
    if (container) {
      delete container.dataset.bundleInit;
      initBundle(container);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const container = e.target.querySelector('.lepro-bundle');
    if (container && container.dataset.sectionId && window.__LEPRO_BUNDLE__) {
      delete window.__LEPRO_BUNDLE__[container.dataset.sectionId];
    }
  });
})();
